"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var breadcrumbs_1 = require("../../components/common/breadcrumbs");
var react_apollo_1 = require("react-apollo");
var show_season_summary_1 = require("../../core/gql/queries/show-season-summary");
var _ = require("lodash");
var tableHeaders = [
    {
        name: "col1",
        label: "Program/Season",
        isSortable: false,
        align: "left",
        mods: "u-size2of11",
    },
    {
        name: "col2",
        label: "Teams",
        isSortable: false,
        align: "right",
        mods: "u-size1of11",
    },
    {
        name: "col3",
        label: "Players",
        isSortable: false,
        align: "right",
        mods: "u-size1of11",
    },
    {
        name: "col4",
        label: "Commissioners",
        isSortable: false,
        align: "right",
        mods: "u-size2of11",
    },
    {
        name: "col5",
        label: "Coaches/Managers",
        isSortable: false,
        align: "right",
        mods: "u-size2of11",
    },
];
var ProgramReport = function (props) {
    var orgId = props.match.params.orgId;
    var orgIdAsInt = parseInt(orgId);
    var showSeasonSummaryResponse = react_apollo_1.useQuery(show_season_summary_1.ShowSeasonSummary, { variables: { organizationId: orgIdAsInt, isArchived: false } });
    var programs = _.get(showSeasonSummaryResponse.data, "showOrganization.programs", []);
    var createTableRowData = function (programs, organizationId) {
        return _.flatMap(programs, function (program, pidx) {
            return program.seasonSummaries.map(function (season, sidx) {
                var link = "/organizations/" + organizationId + "/programs/" + program.id;
                return {
                    id: parseInt(pidx + "" + sidx),
                    col1: (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement(react_router_dom_1.Link, { to: link }, program.name)),
                        React.createElement("div", null,
                            React.createElement("small", null, season.name)))),
                    col2: season.activeTeamCount || 0,
                    col3: season.activeAssignedPlayerCount || 0,
                    col4: season.activeCommissionerCount || 0,
                    col5: season.activeManagerCount || 0,
                };
            });
        });
    };
    return (React.createElement("div", { id: "program", className: "container" },
        React.createElement("div", { className: "page-content u-xs-padXl u-flexExpandSides" },
            React.createElement("div", { className: "page-content-header Grid u-flexAlignItemsCenter" },
                React.createElement("div", { className: "Grid-cell u-xs-size1of2" },
                    React.createElement(breadcrumbs_1.default, { breadcrumbs: [
                            {
                                text: "Programs",
                                link: "/organizations/" + orgId + "/programs",
                            },
                            { text: "Programs Report" },
                        ] }))),
            React.createElement("div", { className: "page-content-body" },
                React.createElement("h3", null, "Current Active Seasons"),
                React.createElement(teamsnap_ui_1.Table, { isLoading: showSeasonSummaryResponse.loading, columns: tableHeaders, rows: createTableRowData(programs, orgIdAsInt) })))));
};
exports.default = ProgramReport;
//# sourceMappingURL=program-report.js.map